/*
 * @Description: 房源租赁列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2022-01-18 12:09:20
 * @LastEditors: zhao - 🍉
 */

import React from 'react';
import {Divider, message,Icon} from 'antd';
import { Link } from 'react-router-dom';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import { postFrom, config, transterQuery } from '../../axios';
import {dicHouseStatus, dicRentGrowth} from '../../axios/dictionaries';
import LeaseSigning from '../../containers/LeaseSigning';
import moment from 'moment';
import { handleExportParams } from '../../utils';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                shortName: '',
                buildingNo: '',
                projectKeyword:'',
                floor: '',
                roomNo: '',
                status: '',
                keyword: '',
                pageSize: 10,
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            tableTotalMny: 0, //表格总金额
        }
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_house_findHouseRentPage, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleSigning = (e, msg) => { //签约
        this.signingRef.loadPack(msg);
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            tableTotalMny,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper search-wrapper-two" style={{ flexDirection: 'column' }}>
                    <SuperForm
                        onRef={ref => this.superFormRef = ref}
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                    <div className="search-btn-list">
                        <AuthButton authkey="c-3-2" type="primary" icon="export" href={`${config.API_house_houseRentExprotDate}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                        导出
                        </AuthButton>
                        <AuthButton authkey="c-3-2" type="primary" icon="export" href={`${config.API_house_exportContractTemplate}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                        生成合同模板
                        </AuthButton>
                    </div>
                </div>
                <TableDOM
                    columns={columns({ handleSigning: this.handleSigning })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    totalMny={tableTotalMny}
                    current={current}
                    onChange={this.handleSearch}
                />
                <LeaseSigning
                    onRef={ref => this.signingRef = ref}
                    handleGetList={this.handleSearch}
                />
            </PageWrap>
        )
    }
}

const searchData = () => {
    let data = [
        {
            tagName: 'Input',
            formConfig: { name: 'shortName' },
            attribute: { placeholder: '请输入商户简称', style: { width: '130px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'buildingNo' },
            attribute: { placeholder: '请输入小区/楼栋', style: { width: '130px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'projectKeyword' },
            attribute: { placeholder: '请输入项目名称或项目编号', style: { width: '200px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'floor' },
            attribute: { placeholder: '请输入楼层', style: { width: '130px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'roomNo' },
            attribute: { placeholder: '请输入房号', style: { width: '130px' } },
        },
        {
            tagName: 'Select',
            formConfig: { name: 'status' },
            attribute: { placeholder: '请选择租赁状态', style: { width: '130px' } },
            optionData: [{ title: '全部', value: '' }].concat(dicHouseStatus),
            notResult: '',
        },
        {
            tagName: 'Select',
            formConfig: { name: 'rentGrowth' },
            attribute: { placeholder: '请选择租金参考值状态', style: { width: '170px' } },
            optionData: [{ title: '全部', value: '' }].concat(dicRentGrowth),
            notResult: '',
        },
    ];
    handleExportParams().merchantId && data.splice(0, 1)
    return data;
};

const columns = ({ handleSigning }) => [
    {
        title: '房源编号',
        dataIndex: 'houseNo'
    },
    {
        title: '小区/楼栋',
        dataIndex: 'buildingName'
    },
    {
        title: '楼层',
        dataIndex: 'floor'
    },
    {
        title: '房号',
        dataIndex: 'roomNo'
    },
    {
        title: '户型',
        dataIndex: 'layout'
    },
    {
        title: '朝向 | 面积(m²)',
        dataIndex: 'direct',
        render(text, record, index) {
            return <span>
                <div>{record.direct}</div>
                {
                    record.area
                        ? <React.Fragment>
                            <div>{record.area}</div>
                        </React.Fragment>
                        : null
                }
            </span>
        }
    },
    {
        title: '租金参考值/实际租金',
        dataIndex: 'rent',
        render(text, record, index) {
            const renderTrend = () => {
                if (!record.rent || !record.monthlyFee) return 
                if (record.rent === record.monthlyFee) return 
                if (record.monthlyFee > record.rent) {

                    return <Icon type="arrow-up" style={{color: 'red'}}  />
                } else {
                    return <Icon type="arrow-down" style={{color: "green"}} />
                }
            }
            return <span>
                <div>{record.rent ? record.rent : '-'}</div>
                <div>
                    <span>{record.monthlyFee ? record.monthlyFee : '-'}</span>
                    <span style={{ marginLeft: 6 }}>{renderTrend()}</span>
                </div>
            </span>
        }
    },
    {
        title: '合同周期',
        dataIndex: 'rentBeginDate',
        render(text, record, index) {
            return <span>
                <div>{record.rentBeginDate ? moment(record.rentBeginDate).format('YYYY-MM-DD') : ''}</div>
                <div>{record.rentEndDate ? moment(record.rentEndDate).format('YYYY-MM-DD') : ''}</div>
            </span>
        }
    },
    {
        title: '租赁状态',
        dataIndex: 'status',
        render(text, record, index) {
            let now = dicHouseStatus.find(item => item.value === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '租客',
        dataIndex: 'customerName',
        render(text, record, index) {
            return <span>
                <div>{record.customerName}</div>
                <div>{record.customerPhone}</div>
            </span>
        }
    },

    {
        title: '商户 | 项目',
        dataIndex: 'shortName',
        render(text, record, index) {
            return <span>
                <div>{record.shortName}</div>
                {
                    record.projectName
                        ? <React.Fragment>
                            <div>{record.projectName}</div>
                        </React.Fragment>
                        : null
                }
            </span>
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 80,
        render(text, record, index) {
            const rentLink = {
                pathname: '/admin/rentContract/list',
                state: { houseId: record.id }
            }
            return (
                <React.Fragment>
                    <AuthButton authkey="c-3-3">
                        <span className="showClickDetail" onClick={(e) => {
                            handleSigning(e, {
                                houseId: record.id,
                                buildingName: record.buildingName,
                                roomNo: record.roomNo
                            })
                        }}
                        >签约</span>
                        <Divider type="vertical" />
                    </AuthButton>
                    <Link to={rentLink}>查看合同</Link>
                </React.Fragment>

            )
        }
    }
];


// WEBPACK FOOTER //
// ./src/page/House/Lease.js